import { useNavigate } from "react-router-dom";
import ComposedCard from "../../../biblio/Cards/ComposedCard";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import TransparentButton from "../../../biblio/Buttons/TransparentButton";

interface Props {
  state: any;
  startIndex: number;
  endIndex: number;
}
const CaseList = ({ state, startIndex, endIndex }: Props) => {
  const navigate = useNavigate();
  const {
    filteredProjects,
    toFilter,
    url,
    type,
    types,
    loading,
    isCompleted,
  } = state;

  return (
    <>
      {url !== "" && (
        <div className="takaful--cases-box">
          {/*  <p>{title}</p>
          <Divider className="takaful--divider" />
          */}
        </div>
      )}
      <div className="takaful--cases">
        {loading ? (
          <div className="takaful--loading-projects-cases">
            <p className="takaful--no-project-message"> جارٍ التحميل</p>
            <DotsLoader />
          </div>
        ) : filteredProjects?.length > 0 ? (
          [...filteredProjects]
            .sort((a: any, b: any) => {
              return a.sequence - b.sequence;
            })
            .slice(startIndex, endIndex)
            .map((project: any, index: number) => (
              <ComposedCard
                key={project.id}
                type={type}
                project={project}
                donation_type_ids={types ?? project.donation_type_ids}
                cardClass={"card-1"}
                isCompleted={isCompleted}
              />
            ))
        ) : toFilter ? (
          <p className="takaful--no-project-message">
            {`لا يوجد ${
              type === "المشاريع"
                ? "مشاريع تتوافق"
                : type === "التبرع العام"
                ? "تبرعات عامة تتوافق"
                : " حالات تتوافق"
            }  مع البحث الذي قمت به`}
          </p>
        ) : (
          filteredProjects?.length === 0 && (
            <p className="takaful--no-project-message">{`لا يوجد ${
              type === "المشاريع"
                ? "مشاريع"
                : type === "التبرع العام"
                ? "تبرعات عامة"
                : "حالات"
            } `}</p>
          )
        )}
      </div>
      <div style={{ justifyContent: "center" }}>
        {filteredProjects?.length > 0 && (
          <TransparentButton
            title={"المزيد من الفرص"}
            onClick={() => navigate(url)}
            className="takaful--return-button takaful--moreProjects-button"
          />
        )}
      </div>
    </>
  );
};
export default CaseList;
